.fingerprint {
  font-family: var(--font-mono);
  font-size: var(--text-min-mono);
  color: var(--ink-soft);
  letter-spacing: 0.01em;
}
